import { Link } from 'react-router-dom';
import {Image} from "semantic-ui-react";

import logo from '/img/imagotipo.svg'

const Logo = () => {

    return (
        <div className="logo _l">
            <Link to="/" className="no-txt"> <span>Ir a Home</span> <Image src={logo} alt="Logo"/> </Link>
            <div className="title">
                <div>Imágenes de</div>
                <div>histopatología veterinaria</div>
            </div>
        </div>
    );
};

export default Logo;
